import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from '@edikk-edikk/redux';
import { Container } from 'inversify';
import {
  ADVERT_LIST_BY_SERVICE_INIT_URL,
  ADVERT_LIST_BY_SERVICE_LOAD_MORE_URL,
  API_ADVERT_LIST_BY_SERVICE_NAME,
} from '#advertList/constants';
import { InitResponseType, LoadMoreResponseType, LoadMorePayloadType } from '#advertList/api/by-service/types';
import { InitPayloadType } from '#advertList/api/types';

const getApiAdvertListByService = (diContainer: Container) => {
  const apiAdvertListByService = createApi({
    reducerPath: API_ADVERT_LIST_BY_SERVICE_NAME,
    baseQuery: getBaseQuery(diContainer),
    endpoints: (builder) => ({
      init: builder.query<InitResponseType, InitPayloadType>({
        query: (
          {
            categoryId,
            nationalityId,
            cityId,
            areaId,
          },
        ) => ({
          url: ADVERT_LIST_BY_SERVICE_INIT_URL,
          params: {
            categoryId,
            nationalityId,
            cityId,
            areaId,
          },
        }),
      }),
      loadMore: builder.query<LoadMoreResponseType, LoadMorePayloadType>({
        query: ({
          categoryId,
          nationalityId,
          cityId,
          areaId,
          page,
          serviceId,
        }) => ({
          url: ADVERT_LIST_BY_SERVICE_LOAD_MORE_URL,
          params: {
            categoryId,
            nationalityId,
            cityId,
            areaId,
            page,
            serviceId,
          },
        }),
        async onQueryStarted(
          {
            categoryId,
            nationalityId,
            cityId,
            areaId,
            serviceId,
          },
          { dispatch, queryFulfilled },
        ) {
          const { data } = await queryFulfilled;
          dispatch(
            apiAdvertListByService.util.updateQueryData(
              'init',
              {
                categoryId,
                nationalityId,
                cityId,
                areaId,
              },
              (draft) => {
                draft.advertDataList.chunkDataList.forEach((chunkData) => {
                  if (chunkData.serviceId === serviceId) {
                    chunkData.pagination = data.chunkData.pagination;
                    chunkData.adverts.push(...data.chunkData.adverts);
                  }
                });
              },
            ),
          );
        },
      }),
    }),
  });
  return apiAdvertListByService;
};

export { getApiAdvertListByService };
